import { FC, PropsWithChildren, ReactElement } from "react";

import { TDrawerCloseFunction } from "@ryde/shared";

import { DrawerContentStyled, DrawerHeader } from "./drawer";

export interface IBackgroundImageDrawerProps extends PropsWithChildren {
  onCloseDrawer: TDrawerCloseFunction;
  title?: string;
  Header?: ReactElement;
  Footer?: ReactElement;
}

export const BackgroundImageDrawer: FC<IBackgroundImageDrawerProps> = ({
  onCloseDrawer,
  children,
  title,
  Header,
  Footer,
}) => {
  return (
    <>
      {Boolean(Header) && !title && Header}
      {title !== undefined && (
        <DrawerHeader onCloseDrawer={onCloseDrawer} title={title as string} />
      )}
      <DrawerContentStyled className="drawer-form-with-image">
        {children}
      </DrawerContentStyled>
      {Boolean(Footer) && Footer}
    </>
  );
};
